"use client";
import { useState } from "react";
import BookDemoModal from "@/app/components/BookDemoModal";

const steps = [
  {
    num: "01",
    title: "SEE",
    desc: "Our system scans the primary AI engines to find out if your brand is being recommended - and who is being recommended instead.",
  },
  {
    num: "02",
    title: "PUBLISH",
    desc: "We publish AI-optimized answer-pages on your own domain, built to prime the models to recommend your brand.",
  },
  {
    num: "03",
    title: "CAPTURE",
    desc: "When a buyer clicks through from an AI answer, the enquiry lands in your inbox - attributed, not anonymous.",
  },
  {
    num: "04",
    title: "KNOW",
    desc: "Every lead is tagged with the likely AI engine that sent it, so you know what is working.",
  },
];

export default function CitationConversion() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
    <section className="w-full bg-surface py-14 sm:py-20 lg:py-28">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-14">
        {/* Top row */}
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 mb-10 sm:mb-16">
          <div className="max-w-[480px]">
            <h2 className="font-display text-[26px] sm:text-[32px] lg:text-[40px] font-black text-ink leading-tight tracking-[-0.02em] mb-4 text-balance">
              How it works
            </h2>
            <p className="text-[15px] text-ink-muted leading-relaxed">
              We bridge the gap between AI information retrieval and your bottom line with a 4-step automated framework.
            </p>
          </div>
          <button
            onClick={() => setIsModalOpen(true)}
            className="px-6 py-3 bg-accent text-on-accent font-semibold text-[15px] rounded-lg active:scale-[0.97] transition-transform duration-[160ms] [transition-timing-function:var(--ease-out)] hover:opacity-90 cursor-pointer flex-shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
          >
            Book an Audit Call
          </button>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step) => (
            <div key={step.num}>
              <p className="font-mono text-[52px] font-black text-accent leading-none mb-3">
                {step.num}
              </p>
              <div className="h-px bg-hairline mb-4" />
              <h3 className="font-display font-bold text-[16px] text-ink mb-2">
                {step.title}
              </h3>
              <p className="text-[14px] text-ink-muted leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
    <BookDemoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
